import {StudentModel} from './student.model';
import {Observable} from 'rxjs';
import {DropdownModel} from '../component/dropdown.model';

export class StudentRelationshipModel {

  static RelationshipTypes = {
    parent: 'parent',
    teacher: 'teacher',
    list: function () {

      return [this.parent, this.teacher];
    },
    dropdownList: function () {

      return [
        DropdownModel.generateFromKey(this.parent),
        DropdownModel.generateFromKey(this.teacher)
      ];
    }
  };

  static UserAccessTypes = {
    owner: 'owner',
    admin: 'admin',
    edit: 'edit',
    view: 'view',
    list: function() {
      return [this.owner, this.view, this.admin, this.view];
    },
    dropdownList: function () {

      return [
        DropdownModel.generateFromKey(this.owner),
        DropdownModel.generateFromKey(this.admin),
        DropdownModel.generateFromKey(this.edit),
        DropdownModel.generateFromKey(this.view)
      ];
    }
  };

  public _id: string;
  public studentId: string;
  public userId: string;
  public schoolId: string;
  public relationshipType: string;
  public userAccessType: string;
  public student: StudentModel;

  // used when importing students from csv.
  public email: string;

  static generate(json: any): StudentRelationshipModel {

    const relationship = new StudentRelationshipModel();
    relationship._id = json._id;
    relationship.studentId = json.studentId;
    relationship.userId = json.userId;
    relationship.relationshipType = json.relationshipType;
    relationship.userAccessType = json.userAccessType;

    if (json.student) {
      relationship.student = StudentModel.generateModel(json.student);
    }

    return relationship;

  }

  static generateList(jsonList: any[]): StudentRelationshipModel[] {

    const list = [];

    for (const json of jsonList) {
      const relationship = StudentRelationshipModel.generate(json);
      list.push(relationship);
    }

    return list;

  }

}
